import { Box } from '@material-ui/core';
import type { ReactNode } from 'react';

import { useStyles } from '../../styles';

interface PreviewToolbarProps {
  /** Centered controls: zoom, pager. */
  children: ReactNode;
  /** Right-aligned content, e.g. an Add to Cart button. */
  actions?: ReactNode;
}

/** Toolbar above a preview canvas; its controls stay centered whatever the
 *  width of the right-aligned actions. */
export const PreviewToolbar = ({ children, actions }: PreviewToolbarProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.toolbar}>
      <Box />
      <Box className={classes.toolbarControls}>{children}</Box>
      <Box className={classes.toolbarActions}>{actions}</Box>
    </Box>
  );
};
